"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusResetPasswordUrl = void 0;
const useCopWebUrl_1 = require("./useCopWebUrl");
function useCirrusResetPasswordUrl() {
    const copUrl = useCopWebUrl_1.useCopWebUrl();
    return `${copUrl}/portal/public/resetPassword.html`;
}
exports.useCirrusResetPasswordUrl = useCirrusResetPasswordUrl;
//# sourceMappingURL=useCirrusResetPasswordUrl.js.map